module.exports = __webpack_public_path__ + "static/mobile-phone-0c68fcb85046b674a1d7f3135b6bd04a.png";